import { displayError, displayWarning } from "../../utils/messageToast";
import { SetupAuth } from "../../client";
import { getSkillId } from "../getSkill";
import { getTabId } from "../getTab";
import { displaySuccess } from "../../utils/messageToast";

export const createForm = async (
  setLoadingButtonCreate: React.Dispatch<React.SetStateAction<boolean>>,
  payload: any,
  setForms: React.Dispatch<React.SetStateAction<string>>,
  authorization: string,
  authorizationRA: string,
  nameForm: string,
  skillIdForm: string,
  tabIdForm: string,
  idForm: string,
  ambient: string,
  setTabName: React.Dispatch<React.SetStateAction<string>>,
  setSkillName: React.Dispatch<React.SetStateAction<string>>,
  setIdForm: React.Dispatch<React.SetStateAction<string>>,
  setNameForm: React.Dispatch<React.SetStateAction<string>>,
  setSkillIdForm: React.Dispatch<React.SetStateAction<string>>,
  setTabIdForm: React.Dispatch<React.SetStateAction<string>>,
  isInForce?: boolean,
  payloadOld?: any,
  userId?: string,
  userName?: string | null,
  clientId?: string | null,
  clientName?: string | null,
) => {
  setLoadingButtonCreate(true);
  const normalizedId = (idForm || "").trim();
  const isUpdate = normalizedId.length > 0;

  if (payload === "") {
    displayWarning("Preencha a area com o payload");
    setLoadingButtonCreate(false);
    return;
  }

  if (nameForm === "") {
    displayWarning("Preencha o nome do formulário!");
    setLoadingButtonCreate(false);
    return;
  }

  if (skillIdForm === "") {
    displayWarning("Preencha a habilidade!");
    setLoadingButtonCreate(false);
    return;
  }

  if (tabIdForm === "") {
    displayWarning("Preencha a tabulação!");
    setLoadingButtonCreate(false);
    return;
  }

  await getSkillId(skillIdForm, authorizationRA, ambient, setSkillName, isInForce);
  await getTabId(tabIdForm, authorizationRA, ambient, setTabName, isInForce, skillIdForm);

  try {
    const apiClientCreateTemplate = SetupAuth();
    const {
      data: { data },
    } = await apiClientCreateTemplate.post(
      `/create-form-by-payload?name=${nameForm}&skillId=${skillIdForm}&tabId=${tabIdForm}&id=${isUpdate ? normalizedId : ""
      }`,
      JSON.parse(payload),
      {
        maxBodyLength: Infinity,
      }
    );

    const apiClient = SetupAuth(authorizationRA);
    const updateBody =
      payloadOld !== undefined || userId !== undefined || userName !== undefined || clientId !== undefined || clientName !== undefined
        ? {
          form: data,
          payloadOld: payloadOld ?? null,
          userId: userId ?? "",
          userName: userName ?? null,
          clientId: clientId ?? null,
          clientName: clientName ?? null,
          historyAction: "payload",
        }
        : data;
    const {
      data: updateResponse,
    } = await apiClient.put(`/update-form?ambient=${ambient}`, updateBody, {
      maxBodyLength: Infinity,
    });

    const id =
      updateResponse?.id ??
      updateResponse?.form?.id ??
      updateResponse?.form?.form?.id ??
      null;

    if (!id) {
      throw new Error("ID do formulário não retornado ao atualizar.");
    }

    await apiClient.post(`/publish-form?formId=${id}&ambient=${ambient}`);

    setIdForm("");
    setSkillIdForm("");
    setTabIdForm("");
    setNameForm("");
    setForms("");

    setLoadingButtonCreate(false);
    displaySuccess(isUpdate ? "Formulário atualizado!" : "Formulário criado!");
  } catch (error: any) {
    const data = error?.response?.data;
    const message =
      data?.error ||
      data?.message ||
      error?.message ||
      "Erro ao salvar o formulário!";
    displayError(message);
    setLoadingButtonCreate(false);
    return;
  }
};
